import { Skeleton, Card, CardContent, CardHeader, Separator } from '@bliks-io/ui';
import { OrganizationProfileCardSkeleton } from '@/components/organization/organizationProfileCard';

export function SettingsPageSkeleton() {
  return (
    <div className="flex flex-col h-full">
      <div className="flex-1 p-10 overflow-y-auto">
        {/* Header skeleton */}
        <Skeleton className="h-7 w-48 mb-2" />
        <Skeleton className="h-5 w-96" />

        <div className="flex flex-col gap-6 mt-8">
          <OrganizationProfileCardSkeleton />

          {/* Preferences Card Skeleton */}
          <Card>
            <CardHeader>
              <Skeleton className="h-6 w-32 mb-2" />
              <Skeleton className="h-4 w-96" />
            </CardHeader>
            <CardContent className="space-y-6">
              {/* Default Language */}
              <div className="flex items-center justify-between">
                <Skeleton className="h-5 w-36" />
                <Skeleton className="h-10 w-[300px]" />
              </div>

              <Separator />

              {/* Recording Time */}
              <div className="flex items-center justify-between">
                <Skeleton className="h-5 w-40" />
                <Skeleton className="h-10 w-[300px]" />
              </div>

              <Separator />

              {/* Review Timeframe */}
              <div className="flex items-center justify-between">
                <Skeleton className="h-5 w-36" />
                <Skeleton className="h-10 w-[300px]" />
              </div>
            </CardContent>
          </Card>

          {/* Survey Settings Card Skeleton */}
          <Card>
            <CardHeader>
              <Skeleton className="h-6 w-40 mb-2" />
              <Skeleton className="h-4 w-80" />
            </CardHeader>
            <CardContent className="space-y-6">
              {/* Enable all surveys toggle */}
              <div className="flex items-center justify-between">
                <Skeleton className="h-5 w-48" />
                <Skeleton className="h-6 w-11 rounded-full" />
              </div>

              <Separator />

              {/* Individual survey toggles */}
              {[1, 2, 3].map((i) => (
                <div key={i}>
                  <div className="flex items-center justify-between">
                    <div className="space-y-1">
                      <Skeleton className="h-5 w-56" />
                      <Skeleton className="h-4 w-72" />
                    </div>
                    <Skeleton className="h-6 w-11 rounded-full" />
                  </div>
                  {i < 3 && <Separator className="mt-6" />}
                </div>
              ))}
            </CardContent>
          </Card>
        </div>
      </div>

      {/* Footer skeleton */}
      <div className="flex items-center justify-between p-4 bg-white border-t border-border-5">
        <Skeleton className="h-10 w-32" />
        <Skeleton className="h-10 w-24" />
      </div>
    </div>
  );
}
